import { isMobile } from "./config";

/**
 * Opens an external URL (blueprint preview/download, Stripe...).
 * Mobile: hands it to the MAUI host (system browser) through the HybridWebView bridge.
 * Web: a new tab, or the current tab when `sameTab` (Stripe redirects back to the portal).
 */
export function openExternal(url: string, options: { sameTab?: boolean } = {}) {
  if (isMobile && window.HybridWebView?.SendRawMessage) {
    window.HybridWebView.SendRawMessage(JSON.stringify({ type: "open-url", url }));
    return;
  }
  if (options.sameTab) {
    window.location.assign(url);
    return;
  }
  const opened = window.open(url, "_blank", "noopener,noreferrer");
  if (!opened) window.location.assign(url);
}
